/* ============================================================================
   tier-most-loved.js - fetch live "Most loved" tier from active subscriber counts
   ============================================================================ */

import { app, isConfigured } from "./firebase-config.js?v=20261007m";

let cachedFeaturedTierId = null;
let fetchPromise = null;

export function readCachedMostLovedTierId() {
  if (cachedFeaturedTierId) return cachedFeaturedTierId;
  try {
    const raw = sessionStorage.getItem("ccj_most_loved_tier");
    const id = String(raw || "").trim();
    if (id) {
      cachedFeaturedTierId = id;
      return id;
    }
  } catch (_) {}
  return null;
}

export async function fetchMostLovedTierId() {
  if (!isConfigured || !app) return readCachedMostLovedTierId();
  if (fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const { getFunctions, httpsCallable } = await import(
        "https://www.gstatic.com/firebasejs/10.12.2/firebase-functions.js"
      );
      const functions = getFunctions(app);
      const call = httpsCallable(functions, "getSubscriptionTierCounts");
      const res = await call();
      const tierId = String(res?.data?.most_loved_tier || "").trim() || null;
      if (tierId) {
        cachedFeaturedTierId = tierId;
        try {
          sessionStorage.setItem("ccj_most_loved_tier", tierId);
        } catch (_) {}
      }
      return tierId;
    } catch (err) {
      console.warn("[CookieCodeJar] Most loved tier fetch failed:", err);
      return readCachedMostLovedTierId();
    } finally {
      fetchPromise = null;
    }
  })();

  return fetchPromise;
}
